import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import NawyExclusiveIcon from '../../../../new-components/svg-icons/NawyExclusiveIcon';
import { getPlanDuration } from '../../../../helpers/payment-plan';

const OfferDetails = ({ offer, modalOpen }: any) => {
  const { t } = useTranslation(['cityscape', 'common']);

  const renderPlanType = (installmentType: any) =>
    installmentType?.name === 'Back Loaded' &&
    !modalOpen && (
      <div className="plan-type">
        <div className="escalating-icon">
          <Image
            width={16}
            height={16}
            alt="Offer Tag"
            src="/assets/icons/common/escalating-payment.svg"
          />
        </div>
        {t('escalating_payments', { ns: 'common' })}
      </div>
    );

  const renderOffer = () => {
    if (offer.discount) {
      return (
        <OfferWrapper>
          <OfferTitle>
            {offer.discount}% {t('discount')}
          </OfferTitle>
          {offer.original_payment_plan ? (
            <OfferDescription>
              {t('valid_on')}{' '}
              {offer.original_payment_plan?.down_payment?.percent}%{' '}
              {t('down_payment')}, {offer.original_payment_plan?.years}{' '}
              {t('years')}
            </OfferDescription>
          ) : offer?.description ? (
            <OfferDescription>{offer.description}</OfferDescription>
          ) : null}
          {renderPlanType(offer.original_payment_plan?.installment_type)}
        </OfferWrapper>
      );
    }

    if (offer?.offer?.cash_discount?.percent) {
      return (
        <OfferWrapper>
          <OfferTitle>
            {offer.offer.cash_discount.percent}% {t('cash_discount')}
          </OfferTitle>
          {renderPlanType(offer.offer?.installment_type)}
        </OfferWrapper>
      );
    }

    if (offer?.offer?.down_payment?.percent !== null) {
      return (
        <OfferWrapper>
          <OfferTitle>
            {offer.offer?.down_payment.percent}%{' '}
            <OfferSubtitle>{t('down_payment')},</OfferSubtitle>
            {getPlanDuration({
              years: offer?.offer?.years,
              months: offer?.offer?.months
            })}
            <OfferSubtitle> {t('years')}</OfferSubtitle>
          </OfferTitle>
          {offer.original_payment_plan ? (
            <OriginalPaymentPlan>
              {offer.original_payment_plan?.down_payment?.percent}%{' '}
              {t('down_payment')}, {offer.original_payment_plan?.years}{' '}
              {t('years')}
            </OriginalPaymentPlan>
          ) : offer?.description ? (
            <OfferDescription>{offer.description}</OfferDescription>
          ) : null}
          {renderPlanType(offer.offer?.installment_type)}
        </OfferWrapper>
      );
    }
  };

  return (
    <OfferDetailsContainer modalOpen={modalOpen}>
      {renderOffer()}

      {offer.nawy_exclusive && <NawyExclusiveIcon />}
      {(offer.offer?.installment_type?.name === 'Back Loaded' ||
        offer.original_payment_plan?.installment_type?.name ===
          'Back Loaded') &&
        modalOpen && (
          <PlanTypeModal>
            <div className="escalating-icon">
              <Image
                width={16}
                height={16}
                alt="Offer Tag"
                src="/assets/icons/common/escalating-payment.svg"
              />
            </div>
            {t('escalating_payments', { ns: 'common' })}
          </PlanTypeModal>
        )}
    </OfferDetailsContainer>
  );
};

const OfferDetailsContainer = styled.div<any>`
  display: flex;
  width: 100%;
  height: ${props => (props.modalOpen ? '60px' : '80px')};
  padding: 8px;
  justify-content: space-between;
  border-radius: 8px;
  background: #f7f9fd;
  align-items: center;
  /* gap: 24px; */
  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    height: auto;
  }
`;

const OfferWrapper = styled.div`
  width: 249px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;

  .plan-type {
    display: flex;
    gap: 8px;
    color: #3e4042;
    font-family: materialMedium;
    align-items: center;
    font-size: 9px;
    .escalating-icon {
      padding: 4px;
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      background: #edf1f6;
      img {
        width: 14px;
        height: 14px;
      }
    }
  }
`;

const OfferTitle = styled.span`
  color: #f79008;
  font-family: materialBold;
  font-size: 17px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const OfferSubtitle = styled.span`
  color: #1a2028;
  font-family: materialRegular;
  font-size: 12px;
`;

const OfferDescription = styled.span`
  color: #5b6573;
  font-family: materialMedium;
  font-size: 12px;
`;

const OriginalPaymentPlan = styled.span`
  color: #5b6573;
  font-family: materialMedium;
  text-decoration: line-through;
  font-size: 12px;
`;

const PlanTypeModal = styled.div`
  display: flex;
  min-width: 20%;
  max-width: 20%;
  align-items: center;
  color: #3e4042;
  font-family: materialMedium;
  font-size: 11px;
  gap: 8px;
  .escalating-icon {
    padding: 4px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: #edf1f6;
    img {
      width: 18px;
      height: 18px;
    }
  }
`;

export default OfferDetails;
